import { render, staticRenderFns } from "./SomnambulistUI.vue?vue&type=template&id=e80fe330&scoped=true"
import script from "./SomnambulistUI.vue?vue&type=script&lang=js"
export * from "./SomnambulistUI.vue?vue&type=script&lang=js"
import style0 from "./SomnambulistUI.vue?vue&type=style&index=0&id=e80fe330&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80fe330",
  null
  
)

export default component.exports